
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import '@/validation-rules';

@Component<DiscountInformation>({
	components: {
		ValidationProvider
	}
})
export default class DiscountInformation extends Vue {
	@Prop({ type: Boolean, default: false }) private targetDiscountEnabled!: boolean;
	@Prop({ type: Object, default: () => {} }) private targetDiscountInfo!: DiscountInfo;
	@Watch('targetDiscountInfo')
	private discountInfoChanged() {
		this.mutableDiscountInfo = this.removeDiscountSymbols();
	}

	private mutableDiscountEnabled: boolean = this.targetDiscountEnabled;
	private mutableDiscountInfo: DiscountInfo | any = this.removeDiscountSymbols();

	/**
	 * Reset discount info when the switch is toggled and emit the updated state
	 *
	 * @return {void}
	 */
	private updateDiscountInfo(): void {
		if (!this.mutableDiscountEnabled) {
			Vue.set(this, 'mutableDiscountInfo', {});
		}
		else {
			this.mutableDiscountInfo = {
				codes: [
					{ name: '', value: '' }
				]
			};
		}
		this.$emit('update-discount-info', { enabled: this.mutableDiscountEnabled, info: this.mutableDiscountInfo });
	}

	/**
	 * Remove a discount code at the given index and emit the updated state
	 *
	 * @param {number} index
	 * @return {void}
	 */
	private removeDiscountCode(index: number): void {
		this.mutableDiscountInfo!.codes.splice(index, 1);
		this.$emit('update-discount-info', { enabled: this.mutableDiscountEnabled, info: this.mutableDiscountInfo });
	}

	/**
	 * Append a new empty discount code entry
	 *
	 * @return {void}
	 */
	private addDiscountCode(): void {
		this.mutableDiscountInfo!.codes.push({ name: '', value: '' });
	}

	/**
	 * Remove the $ or % sign since the input is numeric only
	 *
	 * @return {DiscountInfo | any}
	 */
	private removeDiscountSymbols(): DiscountInfo | any {
		return {
			...this.targetDiscountInfo,
			codes: this.targetDiscountInfo?.codes?.length ? this.targetDiscountInfo.codes.map((code: { name: string; value: string }) => ({ ...code, value: code.value.replace(/[$%]/g, '') })) : []
		};
	}
}
